import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-campaign-file-multiadd',
  templateUrl: './projects-campaign-file-multiadd.component.html',
  styleUrls: ['./projects-campaign-file-multiadd.component.scss']
})
export class ProjectsCampaignFileMultiAddComponent implements OnInit {

  dataSent : any;
  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  nombre : any = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private main : MainService,
    private fb : FormBuilder,
    private projectsService : ProjectsService,
    private dialogRef: MatDialogRef<ProjectsCampaignFileMultiAddComponent>,
  ) { 
    this.dataSent = this.data;
  }

  ngOnInit(): void {
    this.loadForm();
    this.preloadFormData();
  }

  preloadFormData(){
    console.log(this.dataSent);
    this.bodyForm.append('folder', this.dataSent.folder as string);
    this.bodyForm.append('id_fase', this.dataSent.phase_id);
    this.bodyForm.append('fase', this.dataSent.phase);
    this.bodyForm.append('id_proyecto', this.dataSent.project.id);
  //this.bodyForm.append('next_vobo_tipo', this.dataSent.next_vobo.tipo);
  //this.bodyForm.append('next_vobo', this.dataSent.next_vobo);
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}]
    });
  }

  onValueChange(files : any)
  { 
    if(files.length > 1)
    {      
      files.splice(1, 1);
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'Sólo puede adjuntarse un documento'
      });
    }

    for (const item of files) {
      if(!(item.name.toLowerCase().endsWith('.zip')))
      {
        const index = files.indexOf(item);
  
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'Solo se permiten documentos en formato .ZIP'
        });
    
        if (index >= 0) {
          files.splice(index, 1);
        }
      }
    }
  }

  uploadFile(){
    if(this.form.value.blob != null && this.form.value.blob?.length!=0){

      this.bodyForm.append("blob", this.form.value.blob[0] as File);
      
      Swal.fire({
        icon: 'info',
        title: 'Subiendo archivo...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.projectsService.uploadCampaignProjectFileMultiple(this.bodyForm).subscribe(
        (result:any)=>{
          if(result.message == 'Success'){
            if(result.errors.length == 0 && result.wrong_format.length == 0 && result.notfound.length == 0){
              Swal.fire({
              icon: 'success',
              title: 'Archivos subidos',
              text: 'Archivos subidos exitosamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
            }else{
              
              Swal.fire({
                  icon: 'warning',
                  title: 'El proceso ha terminado, sin embargo, uno o más archivos no se cargaron correctamente',
                  html: `
                    <div style="max-height:350px; overflow-y:auto; text-align:center; padding:5px;">
                      ${result.notfound.length > 0 ? `
                        <p><strong>Archivos sin diagramación encontrada:</strong></p>
                        <table style="width:95%; margin:auto; border-collapse:collapse; font-size:14px; box-shadow:0 2px 6px rgba(0,0,0,0.1);">
                          <thead>
                            <tr style="background:#e9ecef; color:#343a40;">
                              <th style="padding:8px; border:1px solid #ddd;">Archivo</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${result.notfound.map((f:any) => `
                              <tr>
                                <td style="padding:6px; border:1px solid #ddd; text-align:left;">${f}</td>
                              </tr>`).join('')}
                          </tbody>
                        </table>
                        <br/>
                      ` : ''}
                            
                      ${result.errors.length > 0 ? `
                        <p><strong>Archivos con arte ya aprobado:</strong></p>
                        <table style="width:95%; margin:auto; border-collapse:collapse; font-size:14px; box-shadow:0 2px 6px rgba(0,0,0,0.1);">
                          <thead>
                            <tr style="background:#e9ecef; color:#343a40;">
                              <th style="padding:8px; border:1px solid #ddd;">Archivo</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${result.errors.map((f:any) => `
                              <tr>
                                <td style="padding:6px; border:1px solid #ddd; text-align:left;">${f}</td>
                              </tr>`).join('')}
                          </tbody>
                        </table>
                        <br/>
                      ` : ''}
                            
                      ${result.wrong_format.length > 0 ? `
                        <p><strong>Archivos con nombre incorrecto:</strong></p>
                        <table style="width:95%; margin:auto; border-collapse:collapse; font-size:14px; box-shadow:0 2px 6px rgba(0,0,0,0.1);">
                          <thead>
                            <tr style="background:#e9ecef; color:#343a40;">
                              <th style="padding:8px; border:1px solid #ddd;">Archivo</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${result.wrong_format.map((f:any) => `
                              <tr>
                                <td style="padding:6px; border:1px solid #ddd; text-align:left;">${f}</td>
                              </tr>`).join('')}
                          </tbody>
                        </table>
                      ` : ''}
                    </div>
                  `,
                  width: 650,
                  confirmButtonText: 'Aceptar'
                }).then(() => {            
              this.dialogRef.close({ reload: true });
            });

            }
          }

          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        },
        (err:any)=>{
          this.main.HideLoading();
          if(err.error.message == "Invalid file") {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              html: 'Solo se permiten documentos en formato .zip'
            });
      
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el archivo, por favor vuelve a intentarlo.'
            });
          }
        }
      )
      
  }else{
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'El documento no ha sido adjuntado'
      });
    }
  }

}
